import { useMutation } from '@tanstack/react-query';

import { setLoading } from '../../app/applicationScreenSlice';
import { setAuth } from '../../app/consumerInfoSlice';
import { useAppDispatch } from '../../app/hooks';
import { setNextStep } from '../../app/loginSlice';
import { store } from '../../app/store';
import { Dob } from '../../types';
import { ApiResponse } from '../../types/Api';
import { ApiRequestV2, httpRequestV2 } from '../http/client';
import { Method } from '../http/httpConsts';

export function useVerifyDob() {
  const dispatch = useAppDispatch();
  const auth = store.getState().consumerInfoSelector.auth;

  return useMutation<any, ApiResponse, Dob>({
    mutationFn: (dob: Dob) =>
      verifyDob({
        requestID: auth.requestID,
        dob,
      }),
    onSuccess: (data) => {
      dispatch(setLoading(false));
      dispatch(setNextStep(data.nextStep));
      dispatch(setAuth({ ...auth, requestID: data.requestID }));
    },
    onError: () => dispatch(setLoading(false)),
  });
}

async function verifyDob({ requestID, dob }: { requestID: string; dob: Dob }) {
  const req: ApiRequestV2 = {
    path: '/v1/consumer/mfa/dob',
    method: Method.POST,
    body: {
      requestID,
      dob,
    },
  };
  return httpRequestV2(req);
}
